import React from "react";
import Tooltip from "@mui/material/Tooltip";

// Parse a timecard's flag_reason: a JSON array of strings (old format) or of
// {reason, category} objects ("labor_law" or "operational"), or a bare string.
export function parseFlagReasons(flagReason) {
  if (!flagReason) return [];
  if (flagReason.startsWith("[")) {
    try {
      const parsed = JSON.parse(flagReason);
      return parsed.map((item) =>
        typeof item === "string" ? { reason: item, category: "operational" } : item
      );
    } catch {
      return [{ reason: flagReason, category: "operational" }];
    }
  }
  return [{ reason: flagReason, category: "operational" }];
}

function FlagList({ title, flags, keyPrefix, last }) {
  return (
    <>
      <h4 className="text-slate-700 text-sm font-bold mb-2">{title}</h4>
      <ul className={`space-y-1${last ? "" : " mb-3"}`}>
        {flags.map((flag, idx) => (
          <li key={`${keyPrefix}-${idx}`} className="flex items-start text-xs text-slate-600">
            <span className="mr-2">•</span>
            <span>{flag.reason}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

// Hover tooltip listing a flagged timecard's reasons, split into labor law and
// operational flags. Wraps the status badge it describes.
export default function FlagReasonsTooltip({ flagReason, children }) {
  const flags = parseFlagReasons(flagReason);
  const laborFlags = flags.filter((f) => f.category === "labor_law");
  const operationalFlags = flags.filter((f) => f.category !== "labor_law");
  return (
    <Tooltip
      title={
        <div>
          {laborFlags.length > 0 && (
            <FlagList title="LABOR LAW FLAGS" flags={laborFlags} keyPrefix="ll" last={operationalFlags.length === 0} />
          )}
          {operationalFlags.length > 0 && (
            <FlagList title={laborFlags.length > 0 ? "OPERATIONAL FLAGS" : "FLAG REASONS"} flags={operationalFlags} keyPrefix="op" last />
          )}
        </div>
      }
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "white",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            border: "1px solid #e2e8f0",
            color: "inherit",
            minWidth: "200px",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
}
